module.exports = __webpack_public_path__ + "static/media/card3_2.3ea92b98.png";